import { formatLocaleCurrency } from "@/utils/formatUtils";
import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import { ClientsListView } from "../../../../../../client/components/ClientsListView";
import { ClientFormType } from "../../../../../../client/enums";
import { Client } from "../../../../../../client/types";
import { formatLifeInsuranceTariff } from "../../../../../../lifeinsurancetariff/utils";
import { LifeInsurance } from "../../../../../types";

interface Props {
  insurance: LifeInsurance;
  insuredClient?: Client;
}

const LifeInsuranceView = ({ insurance, insuredClient }: Props) => {
  const { t } = useTranslation();

  const { insuranceData } = insurance;

  return (
    <>
      <Descriptions
        size="small"
        styles={{ label: { width: 200 } }}
        column={2}
        bordered
        items={[
          {
            label: t("contract.attrs.insurances.tariffId"),
            children: formatLifeInsuranceTariff(insurance.tariff),
            span: 2,
          },
          {
            label: t("contract.attrs.insurances.insuranceData.insurancePeriod"),
            children: insuranceData.insurancePeriod,
          },
          {
            label: t("contract.attrs.insurances.insuranceData.insuranceAmount"),
            children: formatLocaleCurrency(insuranceData.insuranceAmount),
          },
        ]}
      />

      {insuredClient && (
        <ClientsListView
          className="margin-top-medium"
          clientsData={[
            {
              client: insuredClient,
              clientFormTypes: [ClientFormType.INSURED],
            },
          ]}
        />
      )}
    </>
  );
};

export default LifeInsuranceView;
